import { Autocomplete, MenuItem, Select, TextField } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { ShowAllSubTask } from "../../../Redux/Slice/SubTask";
import {
  fetchActiveMemberData,
  fetchProjectData,
  fetchTaskById,
  updateTaskById,
} from "../../../Redux/Slice/TaskMasterSlice";

const UpdateTaskForm = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { TaskByIdData, ActiveMemberData, TaskProjectData } = useSelector(
    (state) => state.TaskMaster
  );
  const { AllSubTaskData } = useSelector((state) => state.SubTask);

  const [members, setMembers] = useState([]);
  const [selectedMemberId, setSelectedMemberId] = useState("");

  const [Task, setTask] = useState([]);
  const [selectedTaskId, setselectedTaskId] = useState(null);

  useEffect(() => {
    dispatch(fetchActiveMemberData());
    dispatch(fetchProjectData());
    dispatch(ShowAllSubTask());
    dispatch(fetchTaskById(id));
  }, [dispatch, id]);

  const [formData, setFormData] = useState({
    Description: TaskByIdData?.data?.Description,
    DurationeType: TaskByIdData?.data?.DurationeType,
    TastName: TaskByIdData?.data?.TastName,
    Duration: TaskByIdData?.data?.Duration,
    Project: TaskByIdData?.data?.Project?._id,
    Type: TaskByIdData?.data?.Type,
    Week: TaskByIdData?.data?.Week,
    Day: TaskByIdData?.data?.Day,
    Date: TaskByIdData?.data?.Date,
  });

  useEffect(() => {
    if (TaskByIdData?.data) {
      const task = TaskByIdData?.data || "-";
      setFormData({
        Description: task?.Description || "-",
        DurationeType: task?.DurationeType || "Day",
        TastName: task?.TastName || "-",
        Duration: task?.Duration || "-",
        Project: task.Project?._id || "-",
        Type: task?.Type || "-",
        Week: task?.Week || "-",
        Day: task?.Day || "-",
        Date: task?.Date || "-",
      });
    }
  }, [TaskByIdData]);

  const PROJECTS =
    TaskProjectData?.data?.map((el) => ({
      project_id: el._id,
      project_name: el.project_name,
    })) || [];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const [formErrors, setFormErrors] = useState({});

  // const TaskTypeOptions = [
  //   { id: "One Time", label: "One Time" },
  //   { id: "Daily", label: "Daily" },
  //   { id: "Weekly", label: "Weekly" },
  //   { id: "Monthly", label: "Monthly" },
  //   { id: "Quarterly", label: "Quarterly" },
  //   { id: "Semiannualy", label: "Semiannualy" },
  //   { id: "Yearly", label: "Yearly" },
  // ];

  const validateForm = () => {
    const errors = {};
    if (!formData.Description) {
      errors.Description = "Description is required";
    }
    if (!formData.DurationeType) {
      errors.DurationeType = "DurationeType is required";
    }
    if (!formData.TastName) {
      errors.TastName = "Task Name is required";
    }
    if (!formData.Duration || formData.Duration <= 0) {
      errors.Duration = "Duration must be a positive number";
    }
    if (!formData.Project) {
      errors.Project = "Project Name is required";
    }
    // if (!formData.TeamId) {
    //   errors.TeamId = "At least one member must be selected";
    // }
    if (!formData.Type) {
      errors.Type = "Task Type is required";
    }
    return errors;
  };

  useEffect(() => {
    const assignedSubTasks = TaskByIdData?.data?.SubTask || [];
    setTask(
      assignedSubTasks.map((sub) => ({
        id: sub._id,
        name: sub.SubTaskName,
      }))
    );
  }, [TaskByIdData]);

  const handleSelectChange1 = (e, newValue) => {
    if (newValue) {
      setselectedTaskId({ id: newValue._id, name: newValue.SubTaskName });
    } else {
      setselectedTaskId(null);
    }
  };

  const handleAddMember1 = () => {
    const selectedMember = AllSubTaskData?.data?.find(
      (member) => member._id === selectedTaskId?.id
    );

    if (
      selectedMember &&
      !Task.some((member) => member.id === selectedMember._id)
    ) {
      setTask([
        ...Task,
        { id: selectedMember._id, name: selectedMember.SubTaskName },
      ]);
      setselectedTaskId(null);
    } else {
      toast.error("Sub Task already added or not selected!");
    }
  };

  const handleRemoveMember1 = (id) => {
    setTask(Task.filter((member) => member.id !== id));
    toast.success("Member removed successfully!");
  };

  const handleDragStart1 = (e, index) => {
    e.dataTransfer.setData("text/plain", index);
  };

  const handleDrop1 = (e, dropIndex) => {
    e.preventDefault();
    const dragIndex = e.dataTransfer.getData("text/plain");
    const updatedMembers = [...Task];
    if (dragIndex !== dropIndex.toString()) {
      const [movedMember] = updatedMembers.splice(dragIndex, 1);
      updatedMembers.splice(dropIndex, 0, movedMember);
      setTask(updatedMembers);
    }
  };

  const handleDragOver1 = (e) => {
    e.preventDefault();
  };

  useEffect(() => {
    const initialMembers = TaskByIdData?.data?.TeamId || [];
    setMembers(initialMembers.map((el) => ({ id: el._id, name: el.Name })));
  }, [TaskByIdData]);

  const handleSelectChange = (event, newValue) => {
    setSelectedMemberId(newValue ? newValue._id : "");
  };

  const handleAddMember = () => {
    const selectedMember = ActiveMemberData?.data.find(
      (member) => member._id === selectedMemberId
    );
    if (
      selectedMember &&
      !members.some((member) => member.id === selectedMember._id)
    ) {
      setMembers([
        ...members,
        { id: selectedMember._id, name: selectedMember.Name },
      ]);
      setSelectedMemberId("");
    } else {
      toast.error("Member already added or not selected!");
    }
  };

  const handleRemoveMember = (id) => {
    setMembers(members.filter((member) => member.id !== id));
    toast.success("Member removed successfully!");
  };

  const handleDragStart = (e, index) => {
    e.dataTransfer.setData("text/plain", index);
  };

  const handleDrop = (e, dropIndex) => {
    e.preventDefault();
    const dragIndex = e.dataTransfer.getData("text/plain");
    const updatedMembers = [...members];
    if (dragIndex !== dropIndex.toString()) {
      const [movedMember] = updatedMembers.splice(dragIndex, 1);
      updatedMembers.splice(dropIndex, 0, movedMember);
      setMembers(updatedMembers);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errors = validateForm();
    if (Object.keys(errors)?.length === 0) {
      const TeamId = members.map((member) => member.id);
      const SubTask = Task.map((member) => member.id);
      const data = {
        ...formData,
        TeamId, // Add the array of member ids
        SubTask, // Add the array of task ids
      };

      dispatch(updateTaskById({ id, data }));
      navigate("/taskmaster");
    } else {
      setFormErrors(errors);
    }
  };

  const descriptionRef = useRef(null);
  useEffect(() => {
    if (descriptionRef.current) {
      descriptionRef.current.style.height = "auto";
      descriptionRef.current.style.height =
        descriptionRef.current.scrollHeight + "px";
    }
  }, [formData.Description]);

  return (
    <div className="p-6 max-w-8xl mx-auto bg-white rounded-lg shadow-md">
      <h2 className="text-2xl font-bold mb-6 text-center text-[#122A47]">
        Update Task
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Task Name */}
        <div>
          <label className="block text-gray-700 text-sm font-bold mb-2 uppercase">
            Task Name
          </label>
          <input
            type="text"
            name="TaskName"
            className="w-full px-4 py-2 border border-gray-300 rounded-md"
            value={formData.TastName}
            onChange={handleChange}
          />
        </div>

        {/* Description */}
        <div>
          <label className="block text-gray-700 text-sm font-bold mb-2 uppercase">
            Description
          </label>
          <textarea
            ref={descriptionRef}
            name="Description"
            className="w-full px-4 py-2 border border-gray-300 rounded-md"
            value={formData.Description}
            onChange={handleChange}
          />
        </div>

        {/* Duration */}
        <div>
          <label className="block text-gray-700 text-sm font-bold mb-2 uppercase">
            Duration
          </label>
          <input
            type="text"
            name="Duration"
            className="w-full px-4 py-2 border border-gray-300 rounded-md"
            id="Duration"
            value={formData.Duration}
            onChange={handleChange}
          />
        </div>

        {/* Duration Type */}
        <div>
          <label className="block text-gray-700 text-sm font-bold mb-2 uppercase">
            Duration Type
          </label>

          <Select
            fullWidth
            id="DurationeType"
            name="DurationeType"
            label="Duration Type"
            value={formData.DurationeType}
            onChange={handleChange}
            error={!!formErrors.DurationeType}
            helperText={formErrors.DurationeType}
            sx={{ marginBottom: 3 }}
          >
            <MenuItem value="Day">Day</MenuItem>
            <MenuItem value="Hours">Hours</MenuItem>
          </Select>
        </div>

        {/* Project Name */}
        <div>
          <label className="block text-gray-700 text-sm font-bold mb-2 uppercase">
            Project Name
          </label>
          <Autocomplete
            options={PROJECTS}
            getOptionLabel={(option) => option.project_name || ""}
            value={
              PROJECTS.find(
                (project) => project.project_id === formData.Project
              ) || null
            }
            onChange={(e, newValue) =>
              setFormData((prev) => ({
                ...prev,
                Project: newValue ? newValue.project_id : "",
              }))
            }
            isOptionEqualToValue={(option, value) =>
              option.project_id === value.project_id
            }
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Select Project"
                variant="outlined"
                size="small"
                fullWidth
                error={!!formErrors?.Project}
                helperText={formErrors?.Project}
                className="custom-input"
              />
            )}
          />
        </div>

        {/* Task Type */}
        <div>
          <label className="block text-gray-700 text-sm font-bold mb-2 uppercase">
            Task Type
          </label>
          <Select
            id="Type"
            name="Type"
            value={formData.Type}
            onChange={handleChange}
            label="Task Type"
            className="w-full"
          >
            <MenuItem value="One Time">One Time</MenuItem>
            <MenuItem value="Daily">Daily</MenuItem>
            <MenuItem value="Weekly">Weekly</MenuItem>
            <MenuItem value="Monthly">Monthly</MenuItem>
            <MenuItem value="Quarterly">Quarterly</MenuItem>
            <MenuItem value="Semiannualy">Semiannualy</MenuItem>
            <MenuItem value="Yearly">Yearly</MenuItem>
          </Select>
        </div>

        {/* Select Member*/}
        <div>
          <label className="block text-gray-700 text-sm font-bold mb-2 uppercase">
            Select Member
          </label>
          <Autocomplete
            options={ActiveMemberData?.data || []}
            getOptionLabel={(option) => option.Name || ""}
            value={
              ActiveMemberData?.data?.find((t) => t._id === selectedMemberId) ||
              null
            }
            onChange={handleSelectChange}
            isOptionEqualToValue={(option, value) => option._id === value._id}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Select a member"
                variant="outlined"
                size="small"
                fullWidth
                className="!mb-2"
              />
            )}
          />

          <div className="flex justify-end mt-3">
            <button
              type="button"
              onClick={handleAddMember}
              className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded"
            >
              Add
            </button>
          </div>

          <div className="p-4 w-full bg-white rounded-md shadow">
            <h3 className="text-xl font-semibold mb-3 text-gray-800">
              Members List
            </h3>

            <div className="border border-dashed border-gray-400 p-3 min-h-[50px] rounded-md bg-gray-50">
              {members.length > 0 ? (
                members.map((member, index) => (
                  <div
                    key={member.id}
                    draggable
                    onDragStart={(e) => handleDragStart(e, index)}
                    onDrop={(e) => handleDrop(e, index)}
                    onDragOver={handleDragOver}
                    className="flex justify-between items-center p-2 my-1 border border-gray-300 bg-white rounded-md cursor-grab"
                  >
                    <span className="text-gray-800">{member.name}</span>
                    <button
                      onClick={() => handleRemoveMember(member.id)}
                      className="bg-red-500 hover:bg-red-600 text-white text-sm px-3 py-1 rounded"
                    >
                      Remove
                    </button>
                  </div>
                ))
              ) : (
                <p className="text-gray-500">No members available.</p>
              )}
            </div>
          </div>
        </div>

        {/* Sub Task */}
        <div>
          <label className="block text-gray-700 text-sm font-bold mb-2 uppercase">
            Select Sub Task
          </label>

          <Autocomplete
            options={AllSubTaskData?.data || []}
            getOptionLabel={(option) => option.SubTaskName || ""}
            value={
              selectedTaskId
                ? AllSubTaskData?.data?.find(
                    (el) => el._id === selectedTaskId.id
                  )
                : null
            }
            onChange={(e, newValue) => handleSelectChange1(e, newValue)}
            isOptionEqualToValue={(option, value) => option._id === value?.id}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Select Sub Task"
                variant="outlined"
                size="small"
                fullWidth
                className="!mb-2"
              />
            )}
          />

          <div className="flex justify-end mt-3">
            <button
              type="button"
              onClick={handleAddMember1}
              className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded"
            >
              Add
            </button>
          </div>

          <div className="p-4 w-full bg-white rounded-md shadow mt-4">
            <h3 className="text-xl font-semibold mb-3 text-gray-800">
              Sub Task List
            </h3>

            <div className="border border-dashed border-gray-400 p-3 min-h-[50px] rounded-md bg-gray-50">
              {Task.length > 0 ? (
                Task.map((task, index) => (
                  <div
                    key={task.id}
                    draggable
                    onDragStart={(e) => handleDragStart1(e, index)}
                    onDrop={(e) => handleDrop1(e, index)}
                    onDragOver={handleDragOver1}
                    className="flex justify-between items-center p-2 my-1 border border-gray-300 bg-white rounded-md cursor-grab"
                  >
                    <span className="text-gray-800">{task.name}</span>
                    <button
                      onClick={() => handleRemoveMember1(task.id)}
                      className="bg-red-500 hover:bg-red-600 text-white text-sm px-3 py-1 rounded"
                    >
                      Remove
                    </button>
                  </div>
                ))
              ) : (
                <p className="text-gray-500">No Sub Task available.</p>
              )}
            </div>
          </div>
        </div>

        <div className="mt-8 text-center">
          <button
            type="button"
            className="bg-[#112A47] text-white px-3 py-2 rounded-md text-md font-semibold hover:bg-[#0c2545] transition duration-300 ease-in-out focus:outline-none"
            onClick={(e) => handleSubmit(e)}
          >
            SUBMIT
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateTaskForm;
